<template>
  <div id="content">
    <sweet-modal ref="modal" title="Preview">
      <div></div>
    </sweet-modal>

    <div class="contenair bg-gradient">
      <h1 class="title">
        &nbsp;<i class="fa fa-file-text-o" aria-hidden="true"></i>&nbsp;
        {{ title }}
      </h1>

      <br />
      <MenuOperation
        :id="$route.params._id"
        :type="typejeu"
      />
      <div class="form-container-step">
        <div class="add-op">
          <button
            class="btn-blue-inline btn-resize"
            v-if="!IGsTableGenerated"
            v-on:click="addNewLot"
          >
            <i class="fa fa-plus"></i> Ajouter un lot
          </button>
        </div>
        <br />
        <form class="addcounter ">
          <h1>Gestion des lots</h1>
          <div class="elem">
            <label>Type : </label>
            <select v-model="type" :disabled="IGsTableGenerated">
              <option>IG</option>
              <option>RANKING</option>
            </select>
            <div class="elem" v-if="type == 'RANKING'">
              Ranking : {{ current_ranking }}
            </div>
          </div>

          <br />
          <BulmaAccordion
            :dropdown="false"
            :icon="'custom'"
            :caretAnimation="{
              duration: '.3s',
              timerFunc: 'ease-in-out',
            }"
            :slide="{
              duration: '.5s',
              timerFunc: 'ease',
            }"
          >
            <div
              v-for="(lot, index) in form"
              :v-bind="form"
              :key="index"
              class="item"
            >
              <BulmaAccordionItem>
                <i slot="icon-closed" class="material-icons">
                  <svg
                    data-v-bc7d9a68=""
                    version="1.1"
                    viewBox="0 0 129 129"
                    enable-background="new 0 0 129 129"
                    class="header-icon"
                    style="transition: all 0.3s ease-in-out 0s;"
                  >
                    <g data-v-bc7d9a68="">
                      <path
                        data-v-bc7d9a68=""
                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                      ></path>
                    </g>
                  </svg>
                </i>
                <i slot="icon-open" class="material-icons">
                  <svg
                    data-v-bc7d9a68=""
                    version="1.1"
                    viewBox="0 0 129 129"
                    enable-background="new 0 0 129 129"
                    class="header-icon caret-down"
                    style="transition: all 0.3s ease-in-out 0s;"
                  >
                    <g data-v-bc7d9a68="">
                      <path
                        data-v-bc7d9a68=""
                        d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                      ></path>
                    </g>
                  </svg>
                </i>

                <h4 slot="title" v-if="lot.name">{{ lot.name }}</h4>
                <h4 slot="title" v-else>Lot {{ index + 1 }}</h4>

                <div class="step-content" slot="content">
                  <div class="contenair">
                    <div class="step-contenair">
                      <div class="elem">
                        <label>Variable (sans espace)</label>
                        <input
                          type="text"
                          v-model="lot.name"
                          name="form[][name]"
                          :disabled="IGsTableGenerated"
                          placeholder="lot1"
                        />
                      </div>
                      <div class="elem">
                        <label>Libelé</label>
                        <input
                          type="text"
                          v-model="lot.libelle"
                          name="form[][libelle]"
                          :disabled="IGsTableGenerated"
                          placeholder="Lot 1"
                        />
                      </div>
                      <div class="elem">
                        <label>Image du lot (MB)</label>
                        <multiselect
                          v-model="form[index].img"
                          :options="imgList"
                          name="form[]img"
                          :searchable="false"
                          :show-labels="false"
                          placeholder="Image du lot jeu"
                        >
                        </multiselect>
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <label>Nombre de lots</label>
                        <input
                          type="number"
                          name="form[]nb"
                          :disabled="IGsTableGenerated"
                          v-model="form[index].nb"
                          placeholder="Ex: 500"
                        />
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <label>date de début <span>*</span></label>
                        <template>
                          <vue-datepicker-local
                            name="form[]date_debut"
                            :local="local"
                            format="DD MMMM YYYY"
                            :disabled="IGsTableGenerated"
                            v-model="form[index].date_debut"
                          />
                        </template>
                        <div class="error">
                          {{ errors.first("step1.date_debut") }}
                        </div>
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <label>date de fin <span>*</span></label>
                        <template>
                          <vue-datepicker-local
                            name="form[]date_fin"
                            :local="local"
                            format="DD MMMM YYYY"
                            :disabled="IGsTableGenerated"
                            v-model="form[index].date_fin"
                          />
                        </template>
                        <div class="error">
                          {{ errors.first("step1.date_fin") }}
                        </div>
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <label>Priorité <span>*</span></label>
                        <input
                          type="number"
                          name="form[]priority"
                          :disabled="IGsTableGenerated"
                          v-model.number="form[index].priority"
                        />
                        <div class="error">
                          {{ errors.first("step1.date_fin") }}
                        </div>
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <Checkbox
                          id="constantNumberPerDay"
                          v-model="form[index].constantNumberPerDay"
                        >
                          <label for="constantNumberPerDay"
                            >Nombre constant d'ig par jour ?</label
                          >
                        </Checkbox>

                        <i v-if="form[index].constantNumberPerDay"
                          >{{ igperday(form[index]).nb }}igs/j +
                          {{ igperday(form[index]).rest }}igs en
                          {{ igperday(form[index]).nbDays }} jours</i
                        >
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <label>Type de jeu</label>
                        <multiselect
                          v-model="form[index].type"
                          :options="typeList"
                          name="form[]type"
                          :searchable="false"
                          :show-labels="false"
                          v-validate="'required'"
                          :disabled="IGsTableGenerated"
                          placeholder="Type de jeu"
                        >
                        </multiselect>
                      </div>
                      <div class="elem" v-if="type == 'IG'">
                        <label>Tranche Horaire <span>*</span></label>
                        <div class="tranche">
                          De&nbsp;&nbsp;
                          <vue-timepicker
                            style="width:45%"
                            :disabled="IGsTableGenerated"
                            v-model="form[index].heure_debut"
                          ></vue-timepicker>
                          à &nbsp;
                          <vue-timepicker
                            style="width:45%"
                            :disabled="IGsTableGenerated"
                            v-model="form[index].heure_fin"
                          ></vue-timepicker>
                        </div>
                      </div>

                      <div class="elem">
                        <label>TITRE PERDU/GAGNER (MB) </label>
                        <input
                          type="text"
                          name="form[]titre_mb"
                          v-model="form[index].titre_mb"
                          placeholder="Ex: Bravo vous avez gagné"
                        />
                      </div>
 <div class="elem"></div>
                      <div class="elem" style="width:100%">
                        <label
                          >INFORMATIONS SUR L'ENVOI DU LOT (MB... HTML
                          OK)</label
                        >
                        <i
                          v-if="!htmlview[7]"
                          @click="toogleViewcode(0)"
                          class="fas fa-solid fa-code edithtml"
                        ></i>
                        <i
                          v-else
                          @click="toogleViewcode(0)"
                          class="fas fa-eye-slash edithtml"
                        ></i>
                        <quill-editor
                          v-if="!htmlview[0]"
                          class="editgab"
                          style="width:100%; height:150px"
                          ref="myQuillEditor"
                          v-model="form[index].informations"
                          :options="editorOptionGabarit"
                        />
                          <prism-editor v-if="htmlview[0]" style="width:95%; height:170px" class="my-editor" :line-numbers="true" :highlight="highlighter" v-model="form[index].informations" ></prism-editor>
                  
                        <br>&nbsp;<br>
                      </div>

                      <div class="elem" v-if="type == 'RANKING'">
                        <label
                          >Rangs gagnants (ex: 17,42,56,87,99,1023 ....)<span
                            >*</span
                          ></label
                        >
                        <textarea
                          cols="70"
                          rows="10"
                          v-model="lot.ranking_gagnants"
                        ></textarea>
                      </div>
                    </div>

                    <a
                      class="deletestep"
                      v-if="!IGsTableGenerated"
                      v-on:click="removeLot(index)"
                      ><i class="fa fa-trash-o"></i> Supprimer ce lot</a
                    >
                  </div>
                </div>
              </BulmaAccordionItem>
            </div>
          </BulmaAccordion>
          <br />

          <div class="form-end">
            <button
              type="button"
              v-if="lotsObjectId && !IGsTableGenerated && type == 'IG'"
              class="btn-blue btn-resize"
              v-on:click.prevent="generateIGTable"
            >
              <i class="fa fa-gift"></i> Générer la table d'IG
            </button>
            <button
              type="button"
              v-if="!IGsTableGenerated"
              class="btn-blue btn-resize"
              v-on:click.prevent="sumbitForm"
            >
              <i class="fa fa-save"></i> Sauvegarder
            </button>
            <button
              type="button"
              v-else
              class="btn-blue btn-resize"
              @click="downloadIGTable($route.params._id)"
              ><i class="fa fa-download"></i> Télécharger la table d'IG
            </button>
            <router-link
              tag="button"
              class="btn-blue btn-resize"
              :to="'/gains/' + $route.params._id"
              >View Lots</router-link
            >
          </div>
        </form>

         <!-- <div class="container addcounter ">
          <h2>Forcer les IG pour test</h2>
          <i
            >L'operation doit etre en ENV = TEST pour que les IG puissent être
            forcés</i
          >
          <multiselect
            v-model="dev.status"
            :options="['PERD', 'GAGNE', 'OFF']"
            :searchable="false"
            v-validate="'required'"
            placeholder="Status"
          ></multiselect>
          <div v-if="dev.status == 'GAGNE'">
            <br />
            <multiselect
              v-model="dev.name"
              :options="lotDisplayList"
              :searchable="false"
              v-validate="'required'"
              placeholder="Lot"
            >
            </multiselect>
          </div>
          <br />
          <div class="form-end">
            <button type="button" class="btn-blue" @click="saveDevMode()">
              <i class="fa fa-check"></i> Force IG
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import MenuOperation from "../components/MenuOperation";
import Multiselect from "vue-multiselect";
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Vue from "vue";
import VueDatepickerLocal from "vue-datepicker-local";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";
import Checkbox from "vue-material-checkbox";
import Verte from "verte";
import "verte/dist/verte.css";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor, Quill } from "vue-quill-editor";

import { downloadBlob } from '../utils'

let BackgroundStyle = Quill.import("attributors/style/background");
Quill.register(BackgroundStyle, true);

let DirectionStyle = Quill.import("attributors/style/direction");
Quill.register(DirectionStyle, true);

let FontStyle = Quill.import("attributors/style/font");
Quill.register(FontStyle, true);

let SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = ["0.8rem", "1rem", "1.5rem", "2rem", "2.6rem"];
Quill.register(SizeStyle, true);

var Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register(Block, true);

const Embed = Quill.import("blots/embed");

Quill.register(
  class extends Embed {
    static create(key) {
      let node = super.create();
      node.setAttribute("contenteditable", true);
      node.setAttribute("class", "headerlogo");
      node.innerHTML = `${key}`;
      return node;
    }
    static value(node) {
      return node.dataset.key;
    }

    static blotName = "customEmbed";
    static className = "customEmbed";
    static tagName = "div";
  }
);


export default {
  components: {
    MenuOperation,
    quillEditor,
    Multiselect,
    VueDatepickerLocal,
    BulmaAccordion,
    BulmaAccordionItem,
    SweetModal,
    VueTimepicker,
    SweetModalTab,
    Checkbox,
    PrismEditor,
  },
  data() {
    return {
      htmlview: [],
      editorOptionGabarit: {
        modules: {
          syntax: false,
          clipboard: {
            matchVisual: false,
          },
          toolbar: {
            container: [
              [{ size: SizeStyle.whitelist }],
              ["bold", "italic", "underline"],
              [
                {
                  color: [
                    "#000000",
                    "#e60000",
                    "#ff9900",
                    "#ffff00",
                    "#008a00",
                    "#0066cc",
                    "#9933ff",
                    "#ffffff",
                    "#facccc",
                    "#ffebcc",
                    "#ffffcc",
                    "#cce8cc",
                    "#cce0f5",
                    "#ebd6ff",
                    "#bbbbbb",
                    "#f06666",
                    "#ffc266",
                    "#ffff66",
                    "#66b966",
                    "#66a3e0",
                    "#c285ff",
                    "#888888",
                    "#a10000",
                    "#b26b00",
                    "#b2b200",
                    "#006100",
                    "#0047b2",
                    "#6b24b2",
                    "#444444",
                    "#5c0000",
                    "#663d00",
                    "#666600",
                    "#003700",
                    "#002966",
                    "#3d1466",
                    "custom-color",
                  ],
                },
              ],
              [{ align: [] }],
              ["link"],
              ["clean"],
            ],
            handlers: {
              color: function(value) {
                if (value == "custom-color") {
                  value = prompt("Enter Hex/RGB/RGBA");
                }
                this.quill.format("color", value);
              },
            },
          },
        },
      },
      showButtons: true,
      clearable: true,
      range: [new Date(), new Date()],
      IGsTableGenerated: undefined,
      title: undefined,
      current_ranking: 0,
      lotsObjectId: undefined,
      local: {
        dow: 0,
        yearSuffix: "",
        monthsHead: "Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Decembre".split(
          "_"
        ),
        months: "Jan_Fev_Mar_Avr_Mai_Jun_Jui_Août_Sept_Oct_Nov_Dec".split("_"),
        weeks: "Lun_Mar_Mer_Jeu_Ven_Sam_Dim".split("_"),
        cancelTip: "Quitter",
        submitTip: "Valider",
      },
      date_debut_op: false,
      date_fin_op: false,
      form: false,
      Filtered: [],
      direction: "ltr",
      opens: "right",
      autoApply: true,
      format: "DD-MM-YYYY",
      separator: " - ",
      applyLabel: "Valider",
      cancelLabel: "Annuler",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: moment.localeData().firstDayOfWeek(),
      minDate: undefined,
      maxDate: undefined,
      showranges: false,
      linkedcalendars: false,
      dev: {
        status: "OFF",
        name: "",
        libelle: "",
      },
      type: "IG",
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      typeList: ["IG", "TAS"],
      imgList: [
        "lot1.png",
        "lot2.png",
        "lot3.png",
        "lot4.png",
        "lot5.png",
        "lot6.png",
        "lot7.png",
        "lot8.png",
        "lot9.png",
        "lot10.png",
      ],
      locale: {
        direction: "ltr", //direction of text
        format: "DD-MM-YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
      },
      typejeu: null,
    };
  },
  computed: {
    lotDisplayList() {
      return [
        ...this.form.map((lot) => {
          return lot.name;
        }),
        "RANDOM",
      ];
    },
    elements() {
      return Object.entries(components)
        .map(([k, v]) => {
          v.input_type = k;
          return v;
        })
        .map((e) => {
          if (e.name === undefined) e.name = e.form.label;
          return e;
        });
    },
  },
  async mounted() {
    let response = await this.$axios.get("/api/operations/" + this.$route.params._id);
    this.title = response.data.title;
    this.date_debut_op = response.data.date_debut;
    this.date_fin_op = response.data.date_fin;
    this.typejeu = response.data.type;

    this.$axios
      .get("/api/v2/lots/" + this.$route.params._id)
      .then((response) => {
        if (response.data) {
          this.IGsTableGenerated = response.data.IGsTableGenerated || false;
          this.dev = response.data.dev || this.dev;
          this.lotsObjectId = response.data._id;
          this.form = response.data.lots || [];
          this.type = response.data.type || "IG";
          this.current_ranking = response.data.current_ranking || 0;

          this.form.forEach((lot) => {
            lot.ranking_gagnants = lot.ranking_gagnants.join(",");
          });
          this.ranking = response.data.ranking || 0;
        } else {
          //     var date = new Date();
          this.form = [];
          //     this.form[0].date_debut = moment(date)
          //       .startOf("day")
          //       .toISOString();
          //     this.form[0].date_fin = moment(date)
          //       .endOf("day")
          //       .toISOString();
          //     this.form[0].heure_debut = { HH: "00", mm: "00" };
          //     this.form[0].heure_fin = { HH: "23", mm: "59" };
          //     this.form[0].priority = 10;
          //     this.form[0].constantNumberPerDay = false;
          //     this.type = "IG";
          //     this.ranking = 0;
        }
      })
      .catch((error) => {
        console.log(error);
        this.form = [];
      });
  },
  methods: {
    async saveDevMode() {
      let lot = this.form.find((lot) => {
        return lot.name == this.dev.name;
      });
      if (lot) {
        this.dev.libelle = lot.libelle;
      }

      try {
        let result = await this.$axios.put("/api/v2/lots/devmode/" + this.$route.params._id, this.dev);
        if (result.data) {
          this.$swal({
            type: "success",
            title: "Modifications du Devmode sauvegardées",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    igperday(lot) {
      const nbDays = moment(lot.date_fin).diff(lot.date_debut, "days") + 1; //include the incomplete last day
      return {
        nb: Math.floor(lot.nb / nbDays),
        rest: lot.nb - Math.floor(lot.nb / nbDays) * nbDays,
        nbDays: nbDays,
      };
    },
            highlighter(code) {
      return highlight(code, languages.js); //returns html
    },
    updateDates(dates) {
      this.dateRange.startDate = moment(dates.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(dates.endDate).format("YYYY-MM-DD");
      var range = this.getDates();
    },
    inputTypeName(input_type) {
      return this.rawElements[input_type].name !== undefined
        ? this.rawElements[input_type].name
        : this.rawElements[input_type].form.label;
    },
    async generateIGTable() {
      if (this.IGsTableGenerated) {
        return;
      }
      this.IGsTableGenerated = true;
      try {
        const { result } = await this.$axios.post("/api/v2/lots/igtable/" + this.$route.params._id);
        this.$swal({
          position: "top-end",
          type: "success",
          title: "Modifications sauvegardées",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (err) {
        alert("Error");
        console.log(err);
        this.IGsTableGenerated = false;
      }
    },
    async downloadIGTable(id) {
      const res = await this.$axios.get(`/api/v2/lots/igtable/${id}/table.csv`, {
        responseType: 'blob',
      })
      downloadBlob('table.csv', res.data)
    },
    async sumbitForm() {
      event.preventDefault();
      this.cleanArray();

      try {
        let rangs = [];
        let errorDuplicateRangs = false;
        let lotsSavable = this.form.map((lot) => {
          console.log(lot);
          if (this.type == "RANKING") {
            if (typeof lot.ranking_gagnants == "string") {
              lot.ranking_gagnants = lot.ranking_gagnants.split(",");
            }
            lot.ranking_gagnants = lot.ranking_gagnants
              .map((rg) => {
                return parseInt(rg);
              })
              .filter((rg) => {
                if (rg > 0 && rangs.indexOf(rg) == -1) {
                  rangs.push(rg);
                  return true;
                } else if (rg > 0) {
                  errorDuplicateRangs = rg;
                  return true;
                }
                return false;
              });
            if (errorDuplicateRangs) {
              return alert(
                `Ranking ${errorDuplicateRangs} trouvé plusieurs fois`
              );
            }
          }
        });

        let found = false;
        let formForSave = [];
        this.form.forEach((lot) => {
          if (formForSave.length === 0) {
            formForSave.push(lot);
          } else {
            found = found || formForSave.some((lot2) => lot.name === lot2.name);
          }
        });
        if (found) {
          this.$swal({
            position: "center",
            type: "error",
            title: "Ce nom de lot existe déjà",
            timer: 2000,
          });
          return;
        }

        let result = await this.$axios.put("/api/v2/lots/update/" + this.$route.params._id,{
            lots: this.form,
            type: this.type,
          }
        );

        if (result.data) {
          this.lotsObjectId = result.data._id;
          this.$swal({
            position: "top-end",
            type: "success",
            title: "Modifications sauvegardées",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    getDates() {
      var date1 = new Date(this.dateRange.startDate);
      var date2 = new Date(this.dateRange.endDate);
      var _1Day = 24 * 3600 * 1000;
      for (
        var date = [], ms = date1 * 1, last = date2 * 1;
        ms < last;
        ms += _1Day
      ) {
        var dt = new Date(ms);
        date.push(moment(dt).format("DD MMM YYYY"));
      }
      return date;
    },
    toogleViewcode(i) {
      Vue.set(this.htmlview, i, !this.htmlview[i]);
    },
    addNewLot: function() {
      event.preventDefault();
      var index = this.form.length;
      var date = new Date();
      this.form.push(Vue.util.extend({}, this.lot));
      this.form[index].date_debut = this.date_debut_op;
      this.form[index].date_fin = this.date_fin_op;
      this.form[index].priority = 10;
      this.form[index].heure_debut = { HH: "00", mm: "00" };
      this.form[index].heure_fin = { HH: "23", mm: "59" };
      this.form[index].constantNumberPerDay = false;
    },
    removeLot: function(index) {
      this.$swal({
        title: "&Ecirc;tes vous sur ?",
        text: "Supprimer ce lot !",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, je le supprime !",
      }).then((result) => {
        if (result.value) {
          Vue.delete(this.form, index);
          this.$swal("Supprimée !", "Ce lot à bien été supprimée.", "success");
        }
      });
    },
    openModal() {
      event.preventDefault();
      this.$refs.modal.open();
      return;
    },
    cleanArray() {
      for (var i in this.form) {
        this.form[i].date_debut = moment(this.form[i].date_debut)
          .startOf("day")
          .toISOString();
        this.form[i].date_fin = moment(this.form[i].date_fin)
          .endOf("day")
          .toISOString();
      }
    },
    goBack() {
      this.$router.push("/operation/" + this.$route.params._id);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>

.card  {
  line-height: 20px !important;
}

.card h4, .tranche {
   line-height: 40px !important; 
}

.datepicker {
  width: 300px;
  font-family: "PT Sans", sans-serif;

  input {
    font-family: "PT Sans", sans-serif;
    border-radius: 5px;
    border: none;
    width: 100%;
  }
}

.datepicker-popup {
  width: 300px !important;
  font-family: "PT Sans", sans-serif;
}
.calendar-head,
.calendar-body,
.calendar-foot {
  width: 300px;
  font-family: "PT Sans", sans-serif;
}
.multiselect__tags {
  line-height: 20px;
}
.tranche {
  display: flex;
}

.headlogo {
  width: 100%;
  margin-top: -20px;
  text-align: center;
}

.ql-toolbar .ql-my-thing {
  width: 60px !important;
}
.ql-toolbar .ql-my-thing:before {
  content: "My Thing";
}
</style>
